import { LanguageDetectorModule } from 'i18next';
import { getDomainLanguage } from './domainLanguage';

export const domainLanguageDetector: LanguageDetectorModule = {
  type: 'languageDetector',
  
  init: function() {
    // Initialization logic if needed
  },
  
  detect: function() {
    // Always prioritize domain-based language detection
    const domainLang = getDomainLanguage();
    
    // Check if there's a URL parameter override
    const urlParams = new URLSearchParams(window.location.search);
    const langParam = urlParams.get('lang');
    
    if (langParam) {
      // Map URL language codes to your i18n language codes
      const languageMap: { [key: string]: string } = {
        zh: 'cn',
        'zh-CN': 'cn',
        'zh-cn': 'cn',
        cn: 'cn',
        en: 'en',
      };
      
      const mappedLang = languageMap[langParam.toLowerCase()];
      if (mappedLang) {
        return mappedLang;
      }
    }
    
    // Otherwise use domain-based detection
    return domainLang;
  },
  
  cacheUserLanguage: function(lng: string) {
    // Cache the language in localStorage
    if (typeof window !== 'undefined' && window.localStorage) {
      window.localStorage.setItem('i18nextLng', lng);
    }
  }
}; 